<mat-toolbar class="!bg-white">
  <span class="flex-1"></span>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<div class="layout-padding max-w-screen-2xl">
  <pr-information-box>
    This is a preview of how the referral will appear to the recipient.
  </pr-information-box>
</div>

<pr-referral-portal [previewReferral]="data.referral" [previewOnly]="true" />
